import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  deletePaper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '40%',
    maxWidth: 500,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  deleteButton: {
    marginLeft: 8
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 36
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 16
  },

  icon: { fontSize: 38, marginBottom: 16 },
  title: { fontSize: 18, textAlign: 'center', fontWeight: 600 },
  subTitle: { fontWeight: 600, marginTop: 16 },
  cancelText: { color: theme.palette.primary.main, fontWeight: 600 },
  changeText: { color: theme.palette.primary.contrastText, fontWeight: 600 }
}))

export default useStyles
